import { MatDialog } from "@angular/material/dialog";
import { Injectable, OnDestroy } from "@angular/core";
import { GridApi, GridOptions } from "@ag-grid-community/core";
import { CurrencyPipe, DatePipe  } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { InventoryService } from "src/app/services/inventory.service";
import { BuyBoxCellRendererComponent } from "src/app/ag-grid-components/buy-box-cell-renderer/buy-box-cell-renderer.component";
import { SimpleListCellRendererComponent } from "src/app/ag-grid-components/simple-list-cell-renderer/simple-list-cell-renderer.component";
import { AmountInShipmentCellRendererComponent } from "src/app/ag-grid-components/amount-in-shipment-cell-renderer/amount-in-shipment-cell-renderer.component";
import { ActionsComponent } from "src/app/components/actions/actions.component";
import { ActionDetailButtonComponent } from "src/app/components/action-detail-button/action-detail-button.component";
import { BooleanFilterComponent } from "src/app/ag-grid-components/boolean-filter/boolean-filter.component";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";
import { CreateVendorItemComponent } from "src/app/components/dialogs/create-vendor-item/create-vendor-item.component";
import { filter, takeUntil } from "rxjs/operators";
import { MapSkuToProductComponent } from "src/app/components/dialogs/map-sku-to-product/map-sku-to-product.component";
import { RankCellRendererComponent } from "src/app/ag-grid-components/rank-cell-renderer/rank-cell-renderer.component";
import { SgSkuQtyCellRendererComponent } from "src/app/ag-grid-components/sg-sku-qty-cell-renderer/sg-sku-qty-cell-renderer.component";
import { MultiFieldCellRendererComponent } from "src/app/ag-grid-components/multi-field-cell-renderer/multi-field-cell-renderer.component";
import { AvgPriceTooltipCellRendererComponent } from "src/app/ag-grid-components/avg-price-tooltip-cell-renderer/avg-price-tooltip-cell-renderer.component";
import { ItemListCellRendererComponent } from "src/app/ag-grid-components/item-list-cell-renderer/item-list-cell-renderer.component";
import { InternalNoteCellRendererComponent } from "src/app/ag-grid-components/internal-note-cell-renderer/internal-note-cell-renderer.component";
import { BuyBoxCellEditorComponent } from "src/app/ag-grid-components/buy-box--cell-editor/buy-box-cell-editor.component";
import { AccountCellRendererComponent } from "src/app/ag-grid-components/account-cell-renderer/account-cell-renderer.component";
import { SkuToolPanelComponent } from "src/app/ag-grid-components/sku-tool-panel/sku-tool-panel.component";
import { PlanyardService } from "../../planyard/planyard.service";
import { GridActionsService } from "../../../data-grid/grid-actions.service";
import { GridApiService } from "../../../data-grid/grid-api.service";
import { HumanizeCamelCasePipe } from '../../../pipes/humanize-camel-case.pipe';
import { ProductBreakdownPanelComponent } from "../../breakdown/product-breakdown-panel/product-breakdown-panel.component";
import { SkuBreakdownPanelComponent } from "../../breakdown/sku-breakdown-panel/sku-breakdown-panel.component";
import { ChannelsCellRendererComponent } from "../../../ag-grid-components/channels-cell-renderer/channels-cell-renderer.component";
import { DateCellRendererComponent } from "./../../../ag-grid-components/date-cell-renderer/date-cell-renderer.component";
import { ImageCellRendererComponent } from "./../../../ag-grid-components/image-cell-renderer/image-cell-renderer.component";
import { LoadingCellRendererComponent } from "../../../ag-grid-components/loading-cell-renderer/loading-cell-renderer.component";
import { NumberAndTrendCellRendererComponent } from "./../../../ag-grid-components/number-and-trend-cell-renderer/number-and-trend-cell-renderer.component";
import { OrderStatusCellRendererComponent } from "../../../ag-grid-components/order-status-cell-renderer/order-status-cell-renderer.component";
import { SizeCellRendererComponent } from "../../../ag-grid-components/size-cell-renderer/size-cell-renderer.component";
import { SkuCellRendererComponent } from "../../../ag-grid-components/sku-cell-renderer/sku-cell-renderer.component";
import { StatusBarRendererComponent } from "../../../ag-grid-components/status-bar-renderer/status-bar-renderer.component";
import { HeaderService } from "../../../components/header/header.service";
import { ConfirmDialogComponent } from "./../../../components/dialogs/confirm-dialog/confirm-dialog.component";
import { ProductDetailComponent } from "../../detail/product-detail/product-detail.component";
import { SnackbarComponent } from '../../../components/snackbar/snackbar.component';
import { CustomHeaderTooltipComponent } from 'src/app/ag-grid-components/custom-header-tooltip/custom-header-tooltip.component';
import { WhLocationgridList_vm } from "src/app/models/warehouse.model";
import { PopupLocationSummeryComponent } from "../../logistic/custome-component/popup-location-summery/popup-location-summery.component";
import { LogisticService } from "../../logistic/logistic.service";
import { TagCellRendererComponent } from "src/app/ag-grid-components/tag-cell-renderer/tag-cell-renderer.component";
import { GridReadyEvent } from "@ag-grid-community/core";
import { StockHistoryCellRendererComponent } from "src/app/ag-grid-components/stock-history-cell-renderer/stock-history-cell-renderer.component";
import { Subject } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class ProductsGridConfigService implements OnDestroy {
  gridApi: GridApi;
  parentProductId;
  detailCellRendererParams;
  parentProductName
  filterParams = {
    defaultOption: "inRange",
    maxNumConditions : 1,
    filterOptions: [
      "equals",
      "notEqual",
      "lessThan",
      "lessThanOrEqual",
      "greaterThan",
      "greaterThanOrEqual",
      {
        displayKey: "inRange",
        displayName: "Between",
        test: {},
      },
    ],
  };
  humanizeCamelCasePipe = new HumanizeCamelCasePipe();
  whLocationgridList_vm: WhLocationgridList_vm;
  firstRender: boolean;
  isGridReady: boolean = false;
  getAllTags = {
    values: (params) =>
      params.success(this.inventoryService.getAllTags()),
    suppressSorting: true,
    defaultToNothingSelected: true
  };
  private destroy$ = new Subject<void>();

  constructor(
    private gridActionsService: GridActionsService,
    public headerService: HeaderService,
    private gridApiService: GridApiService,
    private dialog: MatDialog,
    private planyardService: PlanyardService,
    private inventoryService: InventoryService,
    private currencyPipe: CurrencyPipe,
    private snackBar: MatSnackBar,
    private router: Router,
    private logisticsService:LogisticService
  ) {
    this.gridApiService.gridApi$.pipe(takeUntil(this.destroy$)).subscribe((e: GridReadyEvent) => {
      this.gridApi = e.api;
      this.gridApi.closeToolPanel();
      this.gridApi.deselectAll();
    });
  }

  columnDefs: any = [
    {
      field: "ItemName",
      backendFields: ["ItemId"],
      headerName: "",
      width: 50,
      resizable: false,
      pinned: true,
      setVisible:true,
      cellRenderer: "agGroupCellRenderer",
      valueGetter: () => {
        return "";
      },
    },
    {
      field: "Name",
      sort: "asc",
      backendFields: ["ImageUrl", "Title", "Name", "AccountSkuIds"],
      headerName: "Product Information",
      headerTooltip:"Product Information",
      sortable: true,
      minWidth: 300,
      cellRenderer: "skuCellRendererComponent",
      cellRendererParams: {
        detailAction: this.detailAction.bind(this),
      },
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "Name",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            display: "accordion",
            title: "Description",
            filter: "agTextColumnFilter",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
        ],
      },
    },
    {
      field: "Brand",
      headerTooltip:"Brand",
      backendFields: ["Brand"],
      width: 120,
      minWidth:120,
      filter: "agTextColumnFilter",
    },
    {
      field: "CurrentPrice",
      headerTooltip:"Current Price",
      backendFields: ["CurrentPrice"],
      headerName: "Current Price",
      width: 120,
      minWidth:120,
      filter: "agNumberColumnFilter",
      hide:true,
      valueFormatter: (param) =>
        param.value ? "$" + (parseFloat(Number(param.value).toFixed(2))).toLocaleString('en') : '$0.00',
    },
    {
      field: "Color",
      headerTooltip:"Color",
      backendFields: ["Color"],
      width: 120,
      minWidth:120,
      filter: "agTextColumnFilter",
    },
    {
      field: "Model",
      headerTooltip:"Model",
      backendFields: ["Model"],
      width: 120,
      minWidth:120,
      filter: "agTextColumnFilter",
    },
    {
      field: "AvgPrice",
      headerName:"Avg Price",
      headerTooltip:"Avg Price",
      backendFields: ["AvgPrice"],
      valueFormatter: ((params) =>  {
        var str = params.value?.toString().split('.')[1] || '';
       return str.length >= 3 ? "$" + (parseFloat(Number( params.value).toFixed(3))).toLocaleString('en') : this.currencyPipe.transform(params.value)
      }),
      width: 120,
      minWidth:120,
      filter: "agNumberColumnFilter",
    },
    {
      field: "Mappings",
      headerName: "SKU's",
      headerTooltip:"SKU's",
      backendFields: ["Mappings",'DuplicateSkus'],
      width: 100,
      minWidth:100,
      required:true,
      cellRendererParams: (params) => {
        return {
          isDuplicateSkus:true,
        };
      },
      filter: "agNumberColumnFilter",
      hide: true
    },
    {
      headerName: "Size",
      headerTooltip:"Size",
      backendFields: ["Size"],
      cellRenderer: "sizeCellRendererComponent",
      field: "Size",
      minWidth:120,
      width: 200,
      sortable: false,
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Note",
      headerTooltip:"Note",
      field:"Notes",
      backendFields: ["Notes"],
      width: 150,    
      minWidth:120,
      filter: "agTextColumnFilter", 
      hide: true
    },
    {
      field: "InboundQty",
      headerName: "Inbound Stock",
      headerTooltip:"Qty on PO",
      backendFields: ["InboundQty"],
      width: 150,
      minWidth:120,
      filter: "agNumberColumnFilter",
      valueGetter: (params) => {
        return params.data.InboundQty || 0;
      },

      cellClass: params => {
        return !params.value ? 'gray' : null;

      },
      cellRenderer: "avgPriceTooltipCellRendererComponent",
    },
    {
      field: "AvailbaleStock",
      headerName: "Local Stock",
      headerTooltip:"Warehouse Inventory(including reserved)",
      backendFields: ["AvailbaleStock"],
      width: 150,
      minWidth:120,
      filter: "agNumberColumnFilter",
      valueGetter: (params) => {
        return (params.data.AvailbaleStock ? Number(params.data.AvailbaleStock) : 0).toLocaleString('en')
      },
      cellRenderer: "simpleListCellRendererComponent",
      cellRendererParams: (params) => {
        return { 
          isWhsTooltip:true,
          value:params.data.AvailbaleStock
        };
      },
      cellClass: params => {
        return !params.value ? 'gray' : null;
      },
    },
    {
      field: "Reserved",
      headerName: "Reserved Stock",
      headerTooltip:"Quantity in undeducted shipments",
      backendFields: ["Reserved"],
      width: 150,
      minWidth:120,
       filter: "agNumberColumnFilter",
  
    },
    {
      field: "FbaQty",
      headerName: "FBA Stock",
      headerTooltip:"FBA/WFS Total Stock(not including qty in shipments)",
      backendFields: ["FbaQty"],
      width: 150,
      minWidth:120,
      filter: "agNumberColumnFilter",
      valueGetter: (params) => {
        return (params.data.FbaQty ? Number(params.data.FbaQty) : 0).toLocaleString('en')
      },
 
      cellClass: params => {
        return !params.value ? 'gray' : null;

      },
    },
 {
      headerName: "Total Stock",
      headerTooltip:"Total Stock",
      field: "TotalStock",  
      backendFields: ["TotalStock"],
      width: 150,
      minWidth:120,
      isTooltip:true,
      filter: "agNumberColumnFilter",
      valueGetter: (params) => {
        return (params.data.TotalStock ? Number(params.data.TotalStock) : 0).toLocaleString('en')
      },

      cellClass: params => {
        return !params.value ? 'gray' : null;

      },
    },

    {
      field: "Working",
      backendFields: ["Working"],
      width: 150,
      minWidth:120,
      headerName: "Outbound Stock",
      headerTooltip:"Qty in transit to FBA/WFS deducted or not",
      filter: "agNumberColumnFilter",
      valueGetter: (params) => {
        return (params.data.Working ? Number(params.data.Working) : 0).toLocaleString('en')
      },

      cellClass: params => {
        return !params.value ? 'gray' : null;

      },
    },    
    {
      field: "Vendors",
      headerTooltip:"Vendors",
      backendFields: ['Vendors'],
      headerName: "Vendors",
      width: 150,
      minWidth:120,
      filter: "agTextColumnFilter",
      hide: true,
    },
    {
      field: "Tags",
      headerName: "Tags",
      headerTooltip: "Tags",
      backendFields: ["Tags","TagMapped"],
      required:true,
      width: 120,
      minWidth: 120,
      filter: "agSetColumnFilter",
      cellRenderer: "tagCellrenderer",
      filterParams: this.getAllTags,
      sortable: false
    } ,
    {
      field: "Cases",
      headerName: "Cases",
      headerTooltip:"Cases",
      backendFields: ["Cases"],
      width: 150,
      minWidth:120,
      valueFormatter: (params) => params.value ? Number(params.value).toLocaleString('en') : 0,
      hide: true,
      filter: "agNumberColumnFilter",
    },
    {
      field: "Upc",
      headerName: "UPC",
      headerTooltip:"UPC",
      width: 120,
      minWidth:120,
      backendFields: ["Upc"],
      filter: "agTextColumnFilter"
    },
    {
      field: "DeleteFlag",
      headerName:"Deleted",
      headerTooltip:"Deleted",
      backendFields: ["DeleteFlag"],
      hide: true,
      minWidth:120,
      width:150,
      valueFormatter: (param) => (param.value ? "Yes" : "No"),
      filter: "booleanFilterComponent"
    },
    {
      headerName: "Default Location",
      field: "DefaultLocation",
      headerTooltip:"Default Location",
      minWidth:120,
      width:150,
      backendFields: ["DefaultLocation"],
      filter: "agTextColumnFilter",
    },
    {
      field: "",
      cellRenderer: "actionDetailButtonComponent",
      cellRendererParams: {
        action: this.detailAction.bind(this),
        text: "Details",
      },
      minWidth: 100,
      resizable: false,
      cellStyle: {
        "text-align": "center ",
      },
      sortable: false,
      pinned: 'right',      
      lockPosition: true,
    },
  ];

  purchaseColumnDefs = [
    {
      field: "VendorItemName",
      headerName:"Vendor Item Name",
      headerTooltip: "Vendor Item Name",
      backendFields: ["VendorItemName", "ItemVendorId"],
    },
    {
      field: "Vendor",
      headerTooltip: "Vendor",
      backendFields: ["VendorName"],
      valueGetter: (params) => {
        return params.data.VendorName;
      },
    },
    {
      field: "Price",
      headerTooltip: "Price",
      backendFields: ["Price"],
      valueFormatter: (params) => '$' + params.value.toFixed(4),
    },
    {
      field: "AvgPrice",
      headerName:"Avg Price",
      headerTooltip: "Avg Price",
      backendFields: ["AvgPrice"],
      valueFormatter: (params) => this.currencyPipe.transform(params.value),
    },
    {
      field: "CaseQty",
      headerName:"Case Qty",
      headerTooltip: "Case Qty",
      backendFields: ["CaseQty"],
      valueGetter: ((params) => {
        return (Number(params.data.CaseQty)).toLocaleString('en')
      }),
    },
    {
      field: "CaseRoundingSetting",
      headerName: "Enforce Case",
      headerTooltip: "Enforce Case",
      backendFields: ["CaseRoundingSetting"],
      valueFormatter: (params) =>
        params.value
          ? this.humanizeCamelCasePipe.transform(params.value.toLowerCase())
          : "",
    },
    {
      field: "InboundStock",
      headerTooltip: "InboundStock",
      width: 120,
      backendFields: ["InboundStock"],
      valueGetter: ((params) => {
        return (Number(params.data.InboundStock)).toLocaleString('en')
      }),
    },
   /* {
      field: "TotalStock",
      headerName:"Total Stock",
      headerTooltip: "Total Stock",
      width: 120,
      backendFields: ["TotalStock"],
      valueGetter: ((params) => {
        return (Number(params.data.TotalStock) || 0).toLocaleString('en')
      }),
    },*/
    {

      headerName: "Minimum Order Qty",
      field: "MinimumOrderQty",
      backendFields:["MinimumOrderQty"],
      headerTooltip: "Minimum Order Qty",
      width: 150
},{
      field: "QtyPerVendorUnit",
      headerName:"Qty Per Vendor Unit",
      headerTooltip: "Qty Per Vendor Unit",
      backendFields: ["QtyPerVendorUnit"],
      width: 120,

    },
    {
      field: "DeleteFlag",
      headerName:"Delete Flag",
      headerTooltip: "Delete Flag",
      backendFields: ["DeleteFlag"],
      hide: true,
      filter: "booleanFilterComponent",
    },
    {
      field: "actions",
      headerName: "",
      cellRenderer: "actionsComponent",
      cellRendererParams: {
        edit: this.editItem.bind(this),
        delete: this.deleteItem.bind(this),
      },
    },
  ];

  locationColumnDefs = [
    {
      field: "LocationSummaryId",
      hide: true,
      resizable: false,
    },

    {
      field: "LocationId",
      hide: true,
      resizable: false,
    },
    {
      field: "WarehouseId",
      hide: true,
      resizable: false,
    },
    {
      field: "itemid",
      hide: true,
      resizable: false,
    },
    {
      field: "ItemName",
      hide: true,
      resizable: false,
    },
    {
      field: "WId",
      headerName: "Warehouse",
    },
    {
      field: "VendorItemName",
      headerName: "Vendor Item",
      hide:true
    },

    {
      field: "VendorName",
      headerName: "Vendor name",
      hide:true,
    },
    {
      field: "Qty",
      headerName: "Qty",
    },
    {
      field: "TotalValue",
      headerName: "Total Value",
      valueFormatter: (params) => {
        return '$' + Number(params.value)?.toLocaleString("en")
      }
    },
    {
      field: "LastUpdate",
      headerName: "Last Update",
      valueFormatter: (params) => {
        return params.value
        ? new DatePipe('en-US').transform(params.value, 'MM/dd/YYYY hh:mm a')
          : "";
      },
    },
    {
    field: "",
    headerName: '',
    width: 80,
    cellRenderer: "actionsComponent",
    cellRendererParams: {
      edit: (params) => this.editlocationItemSummery(params,this.parentProductId),
      //delete: (params) => this.deletelocationItemSummery(params),
    },
   }
  ]


  sellingColumnDefs = [
    {
      headerName:'Sku',
      headerTooltip:'Sku',
      field:'Sku',
      cellRenderer:'skuCellRendererComponent',
      sort:"asc",
      sortable:false,
      width:350
    },
    {
      field: "Qty",
      headerTooltip: "Mapped Qty",
      headerName: "Mapped Qty",
    },
    {
      field: "Account",
      headerTooltip: "Sku",
    },
    {
      field: "Channel",
      headerTooltip: "Channel",
      cellRenderer: "channelsCellRendererComponent",
      cellRendererParams: (params) => {
        return {
          channels: [params.value],
          mini: true,
        };
      },
      width: 400,
    },
    {
      field: "Buybox",
      headerName: "BuyBox",
      headerTooltip: "BuyBox",
      width: 160,
      sortable: true,
      cellRenderer: "buyBoxCellRendererComponent",
    },
    {
      field: "Price",
      headerTooltip: "Price",
      width: 80,
      sortable: true,
      valueFormatter: (params) => params.value ? this.currencyPipe.transform(params.value) : '',
      cellStyle: {
        height: "100%",
        display: "flex ",
        "align-items": "center",
      },
    },
    {
      field: "AvailableFbastock",
      headerName: "Available Stock",
      headerTooltip: "Available Stock",
      valueGetter: ((params) => {
        return (params.data.AvailableFbastock)
      }),
    },
    {
      field: "TotalFbastock",
      headerName: "Total Stock",
      headerTooltip: "Total Stock",
      sortable: true,
      valueGetter: ((params) => {
        return (Number(params.data.TotalFbastock)).toLocaleString('en')
      }),
    },
    {
      field: "WorkingQty",
      headerName: "Outbound Stock",
      headerTooltip: "Outbound Stock",
      valueGetter: ((params) => {
        return (Number(params.data.WorkingQty)).toLocaleString('en')
      }),
    },
    {
      field: "Cost",
      headerName: "Avg Cost",
      valueFormatter: (params) => params.value ? this.currencyPipe.transform(params.value) : '$0.00',
    },
    {
      field: "TotalValue",
      headerName: "Total Value",
      valueFormatter: (params) => params.value ? this.currencyPipe.transform(params.value) : '$0.00',
    },
    
    {
      field: "Actions",
      headerName: "",
      cellRenderer: "actionsComponent",
      cellRendererParams: {
        edit: this.editMapping.bind(this),
      },
    },
  ];

  components = {
    skuCellRendererComponent: SkuCellRendererComponent,
    statusBarRendererComponent: StatusBarRendererComponent,
    loadingCellRenderer: LoadingCellRendererComponent,
    orderStatusCellRendererComponent: OrderStatusCellRendererComponent,
    sizeCellRendererComponent: SizeCellRendererComponent,
    channelsCellRendererComponent: ChannelsCellRendererComponent,
    dateCellRendererComponent: DateCellRendererComponent,
    imageCellRendererComponent: ImageCellRendererComponent,
    buyBoxCellRendererComponent: BuyBoxCellRendererComponent,
    simpleListCellRendererComponent: SimpleListCellRendererComponent,
    amountInShipmentCellRendererComponent:
      AmountInShipmentCellRendererComponent,
    actionsComponent: ActionsComponent,
    actionDetailButtonComponent: ActionDetailButtonComponent,
    booleanFilterComponent: BooleanFilterComponent,
    rankCellRendererComponent: RankCellRendererComponent,
    sgSkuQtyCellRendererComponent: SgSkuQtyCellRendererComponent,
    multiFieldCellRendererComponent: MultiFieldCellRendererComponent,
    avgPriceTooltipCellRendererComponent: AvgPriceTooltipCellRendererComponent,
    internalNoteCellRendererComponent: InternalNoteCellRendererComponent,
    itemListCellRendererComponent: ItemListCellRendererComponent,
    numberAndTrendCellRendererComponent: NumberAndTrendCellRendererComponent,
    accountCellRendererComponent: AccountCellRendererComponent,
    buyBoxCellEditorComponent: BuyBoxCellEditorComponent,
    customHeaderTooltipComponent:CustomHeaderTooltipComponent,
    skuToolPanelComponent: SkuToolPanelComponent,
    productBreakdownPanelComponent: ProductBreakdownPanelComponent,
    skuBreakdownPanelComponent: SkuBreakdownPanelComponent,
    tagCellrenderer: TagCellRendererComponent,
    stockHistoryCellRendererComponent:StockHistoryCellRendererComponent
  };

  gridOptions: GridOptions = {
    rowModelType: "serverSide",
    blockLoadDebounceMillis: 1,
    suppressServerSideInfiniteScroll: false,
    suppressCopyRowsToClipboard: true,
    masterDetail: true,
    tooltipShowDelay:800,
    detailRowAutoHeight: true,
    detailRowHeight: 46,
    getRowId: (data:any) => data?.data?.ItemId?.toString(),
    defaultColDef: {
      resizable: true,
      sortable: true,
      filterParams: {
        maxNumConditions : 1,
      },
      menuTabs: ["filterMenuTab"],
      tooltipComponent:"customHeaderTooltipComponent",
    },
    components: this.components,
    statusBar: {
      statusPanels: [
        { statusPanel: "statusBarRendererComponent", align: "left" },
      ],
    },
    rowHeight: 58,
    headerHeight: 50,
    rowSelection: "multiple",
    suppressRowClickSelection: true,
    loadingCellRenderer: "loadingCellRenderer",
    cacheBlockSize: 100,
    pivotPanelShow: "onlyWhenPivoting",
    rowBuffer: 50,
    enableCellChangeFlash: true,
    suppressMenuHide: true,
    icons: {
      menu: '<span class="ag-icon ag-icon-filter" unselectable="on" role="presentation"></span>',
      filter:
        '<span class="ag-icon ag-icon-filter" style="display:none;" unselectable="on" role="presentation"></span>',
    },
    onGridReady: (e) => {
      this.gridApiService.gridApi$.next(e);
      this.firstRender = true;
      this.gridActionsService.applycolumnState(e);
    },
    onColumnVisible: (e) => this.gridActionsService.columnVisible(e,this.isGridReady),
    onColumnPinned: () => this.gridActionsService.saveColumnState(null,this.isGridReady),
    onDragStopped: () => this.gridActionsService.saveColumnState(null,this.isGridReady),
    onSortChanged: () => this.gridActionsService.saveColumnState(null,this.isGridReady),
    onFirstDataRendered:() => this.isGridReady = true,
    onRowClicked: ($event) => {
      this.gridActionsService.updateSelectedRows($event);
      this.gridActionsService.openSidePanel('productBreakdown');
      this.refreshSelectedProduct();
    },
    onFilterChanged: () =>
      this.gridActionsService.updateSelectedFilters("products"),
    onCellKeyDown: (e) => this.gridActionsService.onCellKeyDown(e),
    onModelUpdated: (e) => {
      if (this.firstRender && e.api.getDisplayedRowCount() > 1) {
        this.gridApi.sizeColumnsToFit();
        this.firstRender = false;
      }
    },
  };

  refreshSelectedProduct() {
    const toolpanelComponent = this.gridApi.getToolPanelInstance('productBreakdown');
    if (toolpanelComponent) {
      toolpanelComponent.refresh(null);
    }
  }

  getSellingSubGridOptions() {
    this.gridActionsService.subGridCellFocusedIndex = null;
    return {
      rowHeight: 47,
      headerHeight: 28,
      columnDefs: this.sellingColumnDefs,
      defaultColDef: {
        resizable: true,
        sortable: false,
        lockVisible: true,
      },
      suppressMenuHide: true,
      onGridReady: (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
      },
      onCellKeyDown: (e) => this.gridActionsService.onSubGridCellKeyDown(e),
      components: this.components,
    };
  }

  getPurchasingSubGridOptions() {
    return {
      rowHeight: 35,
      headerHeight: 28,
      columnDefs: this.purchaseColumnDefs,
      defaultColDef: {
        resizable: true,
        sortable: false,
        lockVisible: true,
      },
      suppressMenuHide: true,
      onGridReady: (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
      },
      components: this.components,
    };
  }

  getLocationSubGridOptions() {
    return {
      rowHeight: 35,
      headerHeight: 28,
      columnDefs: this.locationColumnDefs,
      defaultColDef: {
        resizable: true,
        sortable: false,
        lockVisible: true,
      },
      suppressMenuHide: true,
      onGridReady: (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
        this.headerService.updatedSetting.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
          if( this.headerService.useBinLocation){
            let idx =  this.locationColumnDefs.findIndex((res)=> res.field == 'LocationCode');
            if(idx !== -1){
              this.locationColumnDefs.splice(idx,1);
            }
            this.locationColumnDefs.splice(2,0,
              {
                field: "LocationCode",
                headerName: "Location Code",
              }
            )
          }else{
            let idx =  this.locationColumnDefs.findIndex((res)=> res.field == 'LocationCode');
            if(idx !== -1){
              this.locationColumnDefs.splice(idx,1);
            }
          } 
          e.api?.setGridOption('columnDefs', this.locationColumnDefs);     
        });
      },
      components: this.components,
    };
  }

  getSubGridTemplate(params) {
    const currentType = localStorage.getItem(
      StorageKeyEnum.ProductsSubGridType
    );
    if(this.detailCellRendererParams) params.detailGridOptions = this.detailCellRendererParams.detailGridOptions

    return `
        <div class="ag-details-row ag-details-row-auto-height sub-grid-container">
      
        <div class="sub-grid-container_tabs">
          <div id="selling-${
            params.node.rowIndex
          }" class="sub-grid-container_tab ${
      currentType === "selling" ? "sub-grid-container_tab--active" : ""
    }">SKUs</div>
          <div id="purchase-${
            params.node.rowIndex
          }" class="sub-grid-container_tab ${
      currentType === "purchase" ? "sub-grid-container_tab--active" : ""
    }">Vendor Items</div>
    <div id="stock-${params.node.rowIndex
    }" class="sub-grid-container_tab ${
      currentType === "stock" ? "sub-grid-container_tab--active" : ""
    }">Stock</div>
          <div  id="addSku-${params.node.rowIndex}" class="${
      currentType === "purchase" || currentType === "stock" ? "hide" : "aggrid-add-btn"
    }"><i class="fal fa-plus"></i>&nbsp; New Mapping</div>
          <div id="addItem-${params.node.rowIndex}" class="${
      currentType === "selling" || currentType === "stock" ? "hide" : "aggrid-add-btn"
    }"><i class="fal fa-plus"></i>&nbsp; Add New Item</div>
    <div id="addStock-${params.node.rowIndex}" class="${
      currentType === "purchase" || currentType === "selling" ? "hide" : "aggrid-add-btn"
    }"><i class="fal fa-plus"></i>&nbsp; Add Stock</div>
        </div>  
        <div>
      </div>
            <div ref="eDetailGrid" class="ag-details-grid ag-details-grid-auto-height"/>
        </div>
        `;
  }

  getDetails(data) {
    this.dialog
      .open(ProductDetailComponent, {
        data,
      })
      .afterClosed()
      .subscribe((e) => {
        if (e == "refresh")
          this.gridApi.refreshServerSide({ route: [], purge: true });
      });
  }
  
  detailAction(data,event) {
    if (event?.ctrlKey || event?.metaKey) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(["inventory/products", data.ItemId])
      ); 
      window.open(url, '_blank');
    }else{
      this.router.navigate(["inventory/products", data.ItemId]);
    }
  }

  refreshServerSide(): void {
    this.gridApi.refreshServerSide({ route: [], purge: true });
  }

  editMapping(params: any) {
    this.dialog
      .open(MapSkuToProductComponent, {
        width: "700px",
        panelClass: "dialog-container-custom",
        data: {
          sku: params.data,
          callBackFn: (dialogRef, e, actions,isActive) => {
            let index
            let api = isActive ? this.planyardService.SetSkuMapping(e) : this.inventoryService.setItemMapping(e); 
            api.pipe(takeUntil(this.destroy$)).subscribe({
              next: (res) => {
              if (dialogRef) {
                dialogRef.close();
              }
              if (actions) {
                actions[1].spin = false;
              }
              this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 4000,
                  horizontalPosition: 'center',
                  data: {
                    title: "Item mapping updated successfully",
                    action: 'Dismiss',
                    type: 'success',
                  },
                }
            );
            if(isActive){
              index = e.itemQtys.findIndex(
               (item) => item.itemId === params.data.ProductId
             );
             if (index !== -1) {
               const node = params.api.getRowNode(params.node.id) as any;
                  node.data.Qty = e.itemQtys[index].qty;
                  params.api.applyTransaction({ update: [node.data] });
             }
           }else{
             index = e.accountSkuQtys.findIndex(
               (item) => item.accountSkuId === params.data.AccountSkuId
             );
             const node = params.api.getRowNode(params.node.id) as any;
             node.data.Qty = e.accountSkuQtys[index].qty;
             params.api.applyTransaction({ update: [node.data] });
           }
            },
             error: (err) => {
              if (actions) {
                actions[1].spin = false;
              }
              this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 4000,
                  horizontalPosition: 'center',
                  data: {
                    title: err.error?.error[0],
                    action: 'Dismiss',
                    type: 'error',
                  },
                }
            );
            },
          complete:()=>{
              if (dialogRef) {
                dialogRef.close();
               }
              }
            }
           );
          }
        },
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e: any) => {
        
      });
  }

  editItem(params) {
    this.dialog
      .open(CreateVendorItemComponent, {
        width: "700px",
        disableClose: true,
        panelClass: "dialog-container-custom",
        data: {
          productId: params.data.ItemId,
          vendorItem: params.data,
        },
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {
        const node = params.api.getRowNode(params.node.id) as any;
        node.data.CaseQty = e.caseQty;
        node.data.CaseRoundingSetting = e.caseRoundingSetting;
        node.data.ItemId = e.itemId;
        node.data.LocalStock = e.localstock;
        node.data.Note = e.note;
        node.data.Price = e.price;
        node.data.VendorId = e.vendorId;
        node.data.VendorName = e.vendorName;
        node.data.VendorItemName = e.vendorItemName;
        params.api.applyTransaction({ update: [node.data] });
      });
  }

  deleteItem(params) {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Delete Vendor Item",
          message: `Are you sure you want to delete ${params.node.data.VendorItemName}?`,
          warning: `<i class="far fa-exclamation-triangle me-2"></i>Note: If the item is on a PO, it will be archived, not deleted`,
          actions: [
            { text: "Cancel", buttonStyle: "underline" },
            { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
          ],
        },
      })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        this.inventoryService
          .RemoveVendorItem(params.data.ItemVendorId)
          .pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'Vendor Item Deleted Successfully',
                    action: 'Dismiss',
                    type: 'success',
                  },
                }
            );
            const node = params.api.getRowNode(params.node.id) as any;
            params.api.applyTransaction({ remove: [node.data] });
          });
      });
  }

  editlocationItemSummery(params: any,ItemId) {
    this.whLocationgridList_vm = new WhLocationgridList_vm();
    this.whLocationgridList_vm.LocationCode = params.data.LocationCode;
    this.whLocationgridList_vm.WarehouseId = params.data.WarehouseId;
    this.whLocationgridList_vm.locationid = params.data.LocationId;
    this.whLocationgridList_vm.itemId = ItemId;
    this.whLocationgridList_vm.itemName = this.parentProductName ? this.parentProductName :params.data.VendorItemName;
    this.whLocationgridList_vm.locationSummaryId =
      params.data.LocationSummaryId;
    this.whLocationgridList_vm.qty = params.data.Qty;
    this.whLocationgridList_vm.isProductdisable = 1;
    var data :any= this.whLocationgridList_vm;
    if(this.headerService.useBinLocation){
      data.title = 'Edit Warehouse Qty'
    }else{
      data.title = "Adjust Stock Qty";
    }
    this.dialog
      .open(PopupLocationSummeryComponent, {
        width: "335px",
        data,
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {
        const node = params.api.getRowNode(params.node.id)
        node.data.WarehouseName = e.warehouseName;
        node.data.LocationCode = e.locationCode;
        node.data.Qty = e.qty;
        params.api.applyTransaction({ update: [node.data] });
      });
  }

  deletelocationItemSummery(params: any) {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Delete Item From warehouse",
          message: `Are you sure you want to remove this warehouse and its stock?`,
          actions: [
            { text: "Cancel", buttonStyle: "underline" },
            { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
          ],
        },
      })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        const payload = {
          locationSummaryId:params.data.LocationSummaryId
        }
        this.logisticsService
          .DeleteWhLocationSummery(payload)
          .pipe(takeUntil(this.destroy$)).subscribe({
          next: (res) => {
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Warehouse stock deleted successfully',
                  action: 'Dismiss',
                  type: 'success',
                },
              }
            )
            const node = params.api.getRowNode(params.node.id) as any;
            params.api.applyTransaction({ remove: [node.data] });
          },
         error: (err) => {
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: err.error.error[0],
                  action: 'Dismiss',
                  type: 'error',
                },
              }
            )
           }
          });
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
